module.exports = __webpack_public_path__ + "lang/sv.json";


//////////////////
// WEBPACK FOOTER
// ./lang/sv.json
// module id = 84
// module chunks = d-game